import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_General_Ledger_Policy_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_GLRL_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'General Ledger Policy WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    GLRULE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'General Ledger Policy Id', columnResourceName: 'colId', alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    GLRULE_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'General Ledger Policy Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

var GeneralLedgerPolicySearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_GLRL_ID',
        id_ui: 'GLRULE_ID',
        name:  'GLRULE_NAME'},


    searchProviderFields: vUI_General_Ledger_Policy_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_General_Ledger_Policy_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var GeneralLedgerPolicySearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "GeneralLedgerPolicySearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'GLRULE_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'GLRULE_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'GLRULE_ID','GLRULE_NAME', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: GeneralLedgerPolicySearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

var GeneralLedgerPolicySearch: ISearch = {
    searchName: "Find General Ledger Policy",
    renderOptions: { ui5ResourceId: "GeneralLedgerPolicySearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [GeneralLedgerPolicySearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("GeneralLedgerPolicyBO", "GeneralLedgerPolicy", GeneralLedgerPolicySearch, "General Ledger Policy Search")
export {GeneralLedgerPolicySearch}